module.exports = __webpack_public_path__ + "img/none.60a71039.png";